import { ReactNode, useState } from 'react';

interface FormGroupProps {
  children: ReactNode;
  title?: string;
  onClose?: () => void;
  showCloseButton?: boolean;
  defaultCollapsed?: boolean;
}

export const FormGroup = ({
  children,
  title,
  onClose,
  showCloseButton = false,
  defaultCollapsed = false,
}: FormGroupProps) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  return (
    <div className='bg-white rounded-[16px] shadow-[2px_2px_8px_0px_rgba(0,0,0,0.25)]'>
      <div
        className={`space-y-2 p-6 relative ${isCollapsed ? 'py-1' : 'pt-2 pb-6 py-6'}`}
      >
        {title && (
          <div
            className={`relative flex items-center h-[48px] select-none ${isCollapsed ? '' : '-mb-8'}`}
          >
            <div
              className={`absolute left-0 right-0 flex justify-between items-center pointer-events-none`}
            >
              <span className='font-semibold text-sm text-gray-900'>
                {isCollapsed && title}
              </span>
            </div>
            <button
              type='button'
              onClick={() => setIsCollapsed(!isCollapsed)}
              className='ml-auto -mr-1 p-1 hover:bg-gray-100 rounded-full transition-colors z-10'
              title={isCollapsed ? 'Expand' : 'Collapse'}
              style={{
                marginRight: showCloseButton && onClose ? '2.5rem' : undefined,
              }}
            >
              <svg
                className={`w-5 h-5  text-gray-900 transition-transform ${isCollapsed ? '' : 'rotate-180'}`}
                fill='none'
                stroke='currentColor'
                viewBox='0 0 24 24'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={3}
                  d='M6 9l6 6 6-6'
                />
              </svg>
            </button>
            {/* Optional Close Button */}
            {showCloseButton && onClose && (
              <button
                type='button'
                onClick={onClose}
                className='absolute right-0 p-1 hover:bg-gray-100 rounded-full transition-colors z-10'
                title='Close'
              >
                <svg
                  className='w-5 h-5 text-gray-500'
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M6 18L18 6M6 6l12 12'
                  />
                </svg>
              </button>
            )}
          </div>
        )}
        <div
          className={`transition-all duration-200 ${isCollapsed ? 'hidden' : ''}`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
